import React from 'react'
import "./Product.css"
import {Star} from "phosphor-react"

import {useSelector, useDispatch} from "react-redux"

import {addToCart} from "../redux/cartSlice"
import { nanoid } from 'nanoid'

function Product({id, title, image, price, rating}) {
    
    const dispatch = useDispatch()

  return (
        <div className='product'>
            <div className='product-info'>
                <div className='product-title'>{title}</div>
                <div className='product-price'><small>${price}</small></div>
                <div className='product-rating'>

                    {
                    Array(rating).fill().map((_,i) => (<Star key={nanoid()} size={20} color="#f6ce04" weight="fill" />))}
                </div>
            </div>
            <img className='product-image' src ={image} alt="img not available"/>
            <button className='product-add-button' onClick={()=> {dispatch(addToCart(
                    {
                        id:id,
                        title:title,
                        image:image,
                        price:price,
                        rating:rating
                    }))}}>Add to Basket</button>
        </div>
    )
}



export default Product